import React from 'react';
import classNames from 'classnames';
import styles from './BottomPageControlsWrapper.module.scss';

export const BottomPageControlsWrapper: React.FC<
  React.PropsWithChildren<{ className?: string; style?: React.CSSProperties }>
> = ({ className, children, style }) => (
  <div className={classNames(styles.container, className)} style={style}>
    {children}
  </div>
);
